window.axios = require("axios");

const productRecommendationsSection = document.querySelector('.product-recommendations');
const url = productRecommendationsSection.dataset.url;
axios.get(url, {})
.then(function (response) {
	const text = response.data;
	const html = document.createElement('div');
	html.innerHTML = text;
	const recommendations = html.querySelector('.product-recommendations');
	if (recommendations && recommendations.innerHTML.trim().length) {
		productRecommendationsSection.innerHTML = recommendations.innerHTML;
		const swiper_recommended = new window.swiper('.recommendations-slider', {
			slidesPerView: 2,
			spaceBetween: 10,
			loop:true,
			breakpoints: {
				992: {
					slidesPerView: 4
				},
			},
			scrollbar: {
                el: '.collection-swiper-scrollbar.swiper-scrollbar',
            },
			navigation: {
                nextEl: '.recommended-products .swiper-button-next',
                prevEl: '.recommended-products .swiper-button-prev',
            },
			lazy: {
				enabled: true,
				checkInView: false,
				loadOnTransitionStart: true,
				loadPrevNext: true,
				loadPrevNextAmount: 1
			},
		});
	}
})
.catch(function (error) {
		window.log(error);
});